

























































import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
import { UserApi, User } from '@compassdigital/foodworks.ts.sdk';
import { mixins } from 'vue-class-component';
import LifecycleModulkse from '@/store/modules/lifecycle';
import SystemModule from '@/store/modules/system';
import AppModule from '@/store/modules/app';
import EditConfirmation from '@/components/Form/EditConfirmation/index.vue';
import AvailableWeekDay from '@/components/Form/AvailableWeekDay/index.vue';

@Component({
  components: {
    EditConfirmation,
    AvailableWeekDay,
  },
})
export default class ScheduleSettingPartnersEdit extends Vue {
  @PropSync('minService', {}) serviceLocal: any;

  @Prop({}) loading!: boolean;

  public edit: boolean = false;

  public saving: boolean = false;

  private minServiceDaysItems = [
    {
      text: 0,
      value: 0,
    },
    {
      text: 1,
      value: 1,
    },
    {
      text: 2,
      value: 2,
    },
    {
      text: 3,
      value: 3,
    },
    {
      text: 4,
      value: 4,
    },
    {
      text: 5,
      value: 5,
    },
    {
      text: 6,
      value: 6,
    },
    {
      text: 7,
      value: 7,
    },
  ];

  public serviceLocationItems = [
    {
      text: 1,
      value: 1,
    },
    {
      text: 2,
      value: 2,
    },
    {
      text: 3,
      value: 3,
    },
    {
      text: 4,
      value: 4,
    },
    {
      text: 5,
      value: 5,
    },
  ];

  public dayCategories: any = [
    {
      text: 'Sun',
      value: 0,
    },
    {
      text: 'Mon',
      value: 1,
    },
    {
      text: 'Tue',
      value: 2,
    },
    {
      text: 'Wed',
      value: 3,
    },
    {
      text: 'Thu',
      value: 4,
    },
    {
      text: 'Fri',
      value: 5,
    },
    {
      text: 'Sat',
      value: 6,
    },
  ]
}
